import COLORS from '../../utils/constants/colors'

const gameFormFooterStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: '1px solid #ECECEC',
    backgroundColor: '#FFFFFF',
    padding: '14px 24px',
  },
  note: {
    fontSize: 12,
    color: '#9A9A9A',
  },
  asterisk: {
    color: COLORS.coral,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  cancelButton: {
    color: '#7A7A7A',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F2F2F2',
    },
  },
  // '&&' boosts specificity so this wins over ButtonWithLoader's own root class
  // regardless of JSS injection order, without touching its submit behavior.
  submitButton: {
    '&&': {
      backgroundColor: COLORS.coral,
      color: COLORS.white,
      textTransform: 'none',
      padding: '10px 26px',
      borderRadius: 4,
      height: 'auto',
    },
    '&&:hover': {
      backgroundColor: COLORS.coralDark,
    },
    // Disabled must not keep the active coral look. Scope the greyed-out
    // appearance to MUI v4's `.Mui-disabled` class so a blocked submit reads
    // as disabled. No matching disabled token exists in colors.js.
    '&&.Mui-disabled': {
      backgroundColor: '#E7E5E0',
      color: '#A8A8A8',
    },
  },
})

export default gameFormFooterStyles
